const AUTO_NAVIGATE_ON_AUDIO_KEY = 'autoNavigateOnAudio';

// When true (default), pages auto-navigate on audio completion and audio continues when navigating pages.
export function getAutoNavigateOnAudio(): boolean {
  try {
    return localStorage.getItem(AUTO_NAVIGATE_ON_AUDIO_KEY) !== 'false';
  } catch {
    return true;
  }
}

export function setAutoNavigateOnAudio(value: boolean): void {
  try {
    localStorage.setItem(AUTO_NAVIGATE_ON_AUDIO_KEY, String(value));
  } catch {}
}
